import request from '@/utils/request'

export function listParentCategory (query) {
  return request({
    url: '/wechat/parent_category/',
    method: 'get',
    params: query
  })
}

export function editParentCategory (parameter, id) {
  return request({
    url: '/wechat/parent_category/' + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function addParentCategory (parameter) {
  return request({
    url: '/wechat/parent_category/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
export function deleteParentCategory (parentId) {
  return request({
    url: '/wechat/parent_category/' + parentId + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editChildCategory (parameter, id) {
  return request({
    url: '/wechat/category/' + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function deleteChildCategory (id) {
  return request({
    url: '/wechat/category/' + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function addChildCategory (parameter) {
  return request({
    url: '/wechat/category/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function parentCategoryName () {
  return request({
    url: '/wechat/parent_category/name/',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function detailGoods (id) {
  return request({
    url: '/goods/detail/',
    method: 'get',
    params: { id }
  })
}

export function editGoods (data) {
  return request({
    url: '/wechat_mall_goods/',
    method: 'put',
    data
  })
}

export function listCatAndBrand () {
  return request({
    url: '/goods/catAndBrand',
    method: 'get'
  })
}
